import { MosError } from 'src/utils/errors/MosError';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import type { SessionTerminationResponse } from 'src/types/session';

interface DeleteWithReasonParams {
  tenantId?: string;
  reason?: string;
  pathType: 'admin' | 'user';
}

const deleteWithReason = async (
  params?: DeleteWithReasonParams,
): Promise<SessionTerminationResponse> => {
  if (!params?.pathType) {
    throw new Error('Path type is required');
  }

  const queryParams = new URLSearchParams();
  if (params?.tenantId) {
    queryParams.append('tenantId', params.tenantId);
  }
  if (params?.reason) {
    queryParams.append('reason', params.reason);
  }

  const queryString = queryParams.toString();
  let url: string =
    params?.pathType === 'admin'
      ? '/shared/admin/sessions'
      : '/shared/users/me/sessions';

  if (queryString && params?.pathType === 'admin') {
    url += `?${queryString}`;
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<SessionTerminationResponse>(url, {
    method: 'DELETE',
  });

  if (response.data) {
    return response.data;
  }

  throw new MosError({
    error: 'Failed to terminate sessions',
    statusCode: response.status,
  });
};

export default deleteWithReason;
